<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon fas fa-trophy"></i> Premiações <small>Listagem de Premiações</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon fas fa-trophy"></i> Premiações</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title"> Listagem de Premiações</h3>

                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <client-table :options="options">
                            <thead>
                                <tr>
                                    <th>CPF</th>
                                    <th>FUNÇÃO</th>
                                    <th>PRESTADOR</th>
                                    <th>GERENTE</th>
                                    <th>RECEBIMENTO</th>
                                    <th>VENDAS</th>
                                    <th>DESCRIÇÃO DO PRÊMIO / REGRA</th>
                                    <th>PRÊMIO</th>
                                </tr>
                            </thead>
                        </client-table>
                    </div>
                    <div class="card-footer">
                    </div>
                    <div class="overlay">
                        <a class="btn btn-app bg-secondary">
                            <i class="fas fa-spinner fa-pulse"></i> carregando...
                        </a>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            options: {
                "title": "Regra Premios",
                "ajax": {
                    "url": "/api/regra_premio/view",
                    "data": function (d) {
                        return JSON.stringify($.extend({}, d, {
                        }));
                    }
                },
                "columns": [
                    { "mData": 'cpf' },
                    { "mData": 'funcao' },
                    { "mData": 'vendedor_parceiro' },
                    { "mData": 'gerente' },
                    { "mData": 'recebimento' },
                    { "mData": 'total_vendas' },
                    { "mData": 'descricao' },
                    { "mData": 'valor_premio' }
                ]
            }
        };
    }
};
</script>

<style scoped>
</style>